import serviceProject from "../serviceProject";
import api from "../../../api";
import axios from "axios";
import moment from "moment";
import {
  createErrorMessage,
  createSuccessMessage,
  clearance
} from "../../../service";

const MeterUnitRecord = {
  ...serviceProject,
  clearance,
  resource: "meter-unit-records",
  massDeleteRecords(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    params = api.helpers.clearResource(params);
    let preList = this.getPreList("delete", params);
    return api
      .delete(`${preList ? "/" + preList : ""}/${this.resource}/`, params)
      .then(res => {
        createSuccessMessage("delete-meter-unit-records");
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  },
  create(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    let preList = this.getPreList("create", params);
    params._tariff = { id: params.tariff_id };
    params._meter_unit = { id: params.meter_unit_id };
    return api
      .post(`${preList ? "/" + preList : ""}/${this.resource}`, params)
      .then(res => {
        createSuccessMessage("create");
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  },
  update(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    params = api.helpers.clearResource(params);
    let { id, ...paramsWithOutId } = params;
    let preList = this.getPreList("update", params);
    paramsWithOutId._tariff = { id: params.tariff_id };
    paramsWithOutId._meter_unit = { id: params.meter_unit_id };
    return api
      .put(
        `${preList ? "/" + preList : ""}/${this.resource}/${id}`,
        paramsWithOutId
      )
      .then(res => {
        createSuccessMessage("update");
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(res.response.data.errors);
        onError(res);
      });
  },
  export(params = {}) {
    return new Promise(resolve => {
      let preList = this.getPreList("getList", params);
      params.filters = api.helpers.formFilters(params.filters);
      const url = `${this.api.apiUrl}${preList ? "/" + preList : ""}/${
        this.resource
      }:export`;
      const form = createForm(params, url);
      try {
        form.submit();
        removeNodes(form);
        resolve();
      } catch (e) {
        axios({
          url: url + "?" + createQueryString(form),
          method: "GET",
          responseType: "blob"
        }).then(response => {
          const link = createFileLink(
            response.data,
            response.headers["last-modified"],
            params.format
          );
          link.click();
          removeNodes(form, link);
          resolve();
        });
      }
    });
  }
};

function createForm(params, url) {
  const form = document.createElement("form");
  form.setAttribute("method", "get");
  form.setAttribute("action", url);
  form.setAttribute("target", "_blank");
  form.setAttribute("style", "display: none");
  for (const name in params) {
    if (typeof params[name] === "object") {
      params[name];
    } else {
      const field = document.createElement("input");
      field.setAttribute("name", name);
      field.setAttribute("value", params[name]);
      form.appendChild(field);
    }
  }
  document.body.appendChild(form);
  return form;
}
function createFileLink(data, date, format) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.target = "_blank";
  link.download = moment(date).format("YYYY-MM-DD_HH-mm-ss_") + "." + format;
  link.href = url;
  document.body.appendChild(link);
  return link;
}
function createQueryString(form) {
  let formData = new FormData(form);
  let search = new URLSearchParams(formData);
  return search.toString();
}
function removeNodes() {
  const args = [...arguments];
  if (args.length) {
    setTimeout(function() {
      args.forEach(i => i.remove);
    });
  }
}
export default MeterUnitRecord;
